<template>
    <div class="order">
        <div class="luck-btn flex_between"> 
            <div class="flex" style="align-items: center;">
                <p>费用支付计划表-</p>
                <p style="color:#409EFF;">截止{{endDate}}</p>
            </div>
            <div><span>单位：辆/元</span></div>
            
        </div>
        <div id="luckysheet" ref="scrollview"
        @mousewheel="scrollChange" v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            
        </div>
    </div>
</template>
<script>
import { saleHeader,carTypeItem,firstHeader, } from '@/assets/js/cost'
// import { getIndexArrOne,getRC,getIndexArrMonth} from '@/util/getTableData';
export default {
    props:{
        data:{
            type:Object,
            default:{}
        },
        sdate:{
            type:String,
            default:''
        },
        edate:{
            type:String,
            default:''
        },
        carType:{
            type:Array,
            default:[]
        }
    },
    data(){
        return{
            edited:[],
            canEdit:[],
            tableLength:0,
            tableData:this.data,
            date:[],
            endDate:'',
            mydata:[],
            loading:false,
            options:{},
        }
    },
    mounted(){
        let _this = this
        this.options =  {
                container: 'luckysheet', //容器id名
                title: '费用支付表', // 表 头名
                lang: 'zh', // 中文
                showtoolbar: false, // 是否显示工具栏
                showinfobar: false, // 是否显示顶部信息栏
                showsheetbar:false,
                // showstatisticBar:false,
                enableAddRow:false,
                sheetFormulaBar:false,
                enableAddRow:false,
                enableAddBackTop:false,
                accuracy:0,
                cellRightClickConfig:{
                    
                    copy: false, // 复制
                    copyAs: false, // 复制为
                    paste: false, // 粘贴
                    insertRow: false, // 插入行
                    insertColumn: false, // 插入列
                    deleteRow: false, // 删除选中行
                    deleteColumn: false, // 删除选中列
                    deleteCell: false, // 删除单元格
                    hideRow: true, // 隐藏选中行和显示选中行
                    hideColumn: true, // 隐藏选中列和显示选中列
                    rowHeight: false, // 行高
                    columnWidth: false, // 列宽
                    clear: false, // 清除内容
                    matrix: false, // 矩阵操作选区
                    sort: false, // 排序选区
                    filter: false, // 筛选选区
                    chart: false, // 图表生成
                    image: false, // 插入图片
                    link: false, // 插入链接
                    data: false, // 数据验证
	                cellFormat: false // 设置单元格格式
                },
                hook: {
                    cellUpdated: function (r, c, oldValue, newValue, isRefresh) {
                        if(isRefresh){
                            if(_this.edited.length>0){
                                const has = _this.edited.filter(item=>item.r==r&&item.c==c)
                                if(has.length>0){
                                    _this.edited.forEach(item=>{
                                        if(item.r==r&&item.c==c){
                                            item.v = newValue.v
                                        }
                                    })
                                }else{
                                    _this.edited.push({r:r,c:c,v:newValue.v})
                                }
                            }else{
                                _this.edited.push({r:r,c:c,v:newValue.v})
                            }
                            _this.edited.forEach(item=>{
                                item.name = window.luckysheet.getCellValue(item.r,2)
                                item.date = window.luckysheet.getCellValue(0,item.c)
                            })
                            _this.$emit('getEditData',_this.edited)
                            window.luckysheet.exitEditMode()
                           
                        }
                    }
                }
                
            }
        let arr = this.edate.split("-")
        this.endDate = arr[0]+'年'+arr[1]+'月'
        this.tableLength = 7+(this.carType.length*4)
        window.luckysheet.exitEditMode();
        window.luckysheet.destroy();
        // this.handleTest()
        this.getExcelDate()
        const scrollview = this.$refs['scrollview']
        scrollview.addEventListener('scroll', this.scrollChange, true)
       
    },
    methods:{
        scrollChange () {
            window.luckysheet.exitEditMode()
        },
        // 计算年月
        getExcelDate(){
            let sy= Number(this.sdate.split("-")[0]);
            let ey= Number(this.edate.split("-")[0]);
            let sm = Number(this.sdate.split("-")[1]);
            let em = Number(this.edate.split("-")[1]);

            let y ;
            let date = []
            if(sy==ey){//同一年
                if(em>sm){
                    for(let i=sm;i<=em;i++){
                        date.push(`${sy}年${i}月`)
                    }
                }else if(em==sm){
                    date.push(`${ey}年${em}月`)
                }else{
                    this.$DonMessage.warning("结束日期必须在开始日期之后")
                }
            }else if(ey>sy){//不同年
                y = ey-sy
                if(y==1){// 没有间隔的一整年
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }
                if(y>1){//中间有完整一整年
                    let fwy = sy+1
                    let lwy = ey-1
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let year=fwy;year<=lwy;year++){
                        for(let month=1;month<=12;month++){
                            date.push(`${year}年${month}月`)
                        } 
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }

            }else{
                this.$DonMessage.warning("结束日期必须在开始日期之后")
            }
            this.date = date
            this.handleTest()
        },
        demo(){
           
            
            if(this.mydata[0].celldata.length>0){
                window.luckysheet.destroy();
                this.options.data = this.mydata;
                window.luckysheet.create(this.options);
                this.$store.state.excelLoading = false
                // window.luckysheet.setDataVerification(//期初数编辑规则
                //     {
                //         type: 'number_integer',
                //         type2: "bw",
                //         value1: 0,
                //         value2: 99999,
                //         prohibitInput: true
                //     },
                //     {
                //         range: `D2:D${this.tableLength}`
                //     }
                // )
                this.canEdit.map(item=>{
                    window.luckysheet.setDataVerification(
                        {
                            type: 'number',
                            type2: "bw",
                            value1: '0.00',
                            value2: '1000000.00',
                            prohibitInput: true
                        },
                        {
                            range: `F${item}:EX${item}`
                        }
                    )
                })
                let bgArr = []
                bgArr.push(`C5:CX5`,`C7:CX7`)
                this.canEdit.map(item=>{
                    bgArr.push(`C${item}:CX${item}`)
                })
             
                if(bgArr.length>0){
                    window.luckysheet.setRangeFormat("bg", '#E3F2D9', {range:[...bgArr]})
                }
                window.luckysheet.setRangeShow({ row:[0], column:[0] }, {
                    show: false, // 选中状态不要高亮
                })
                // window.luckysheet.setRangeFormat("bg", '#195c96', {range:["A9:X9"]})
            }
        },
        handleTest(){
            
            this.canEdit = []
            this.carType.map((item,i)=>{
                this.canEdit.push(10+4*i)
            })
            this.mydata = [
                {   
                    name: "这个是sheet1",
                    celldata: [],
                    frozen:{
                       type: 'rangeBoth',
                       range: {row_focus: 0, column_focus: 2}
                    },
                   
                    config: {
                        authority:{// 当前工作表的权限配置
                            sheet: 1, // sheet表下标。
                            hintText: "这部分不可以进行修改", // 弹

                            allowRangeList: [
                                // { sqref: `$D$2:$D$${this.tableLength}` },//期初数
                            	{ sqref: '$F$5:$EX$5' },//设置A2~D6为可编辑区域，其它区域不可编辑
                                { sqref: '$F$7:$EX$7' },
                               
                            ],
                        },
                        borderInfo: [],
                    },
                    
                    
                    
                },
            ];
            
            this.canEdit.map(item=>{
                this.mydata[0].config.authority.allowRangeList.push(
                    { sqref: `$F$${item}:$EX$${item}` }
                )
            })
        
            // 表头数据项
            firstHeader.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:0,
                        c:index,
                        v:{
                            bg:"#195c96",
                            bl: 1, 
                            v:item,
                            ht:0,
                            fc:'#fff'
                        },
                        
                    }
                )
            })
            // 年月数据
            if(this.date.length>0){
                this.date.map((item,index)=>{
                    this.mydata[0].celldata.push(
                        {
                            r:0,
                            c:index+5,
                            v:{
                                bg:"#195c96",
                                bl: 1, 
                                v:item,
                                ht:0,
                                fc:'#fff'
                            },

                        }
                    )
                })

            }
            // 添加销量项目名
            saleHeader.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:index+1,
                        c:2,
                        v:{
                            v:item,
                            ht:0
                        }
                    }
                )
            })
            let mc = [
                {
                    "r": 1,
                    "c": 0,
                    "v": {
                        "v":'/',
                        "bl": 1, 
                        'ht':0
                    },
                    "mc": {      
                        "r": 1,  
                        "c": 0,  
                        "rs": 6, 
                        "cs": 1  
                    },

                }, 
                {
                    "r": 1,
                    "c": 1,
                    "v": {
                        "v":'合计',
                        'ht':0,
                        "bl": 1, 
                    },
                    "mc": {       
                        "r": 1,   
                        "c": 1,   
                        "rs": 6, 
                        "cs": 1   
                    },

                },
            ]
            let  merge = {
                "1_0": {
                    "r": 1,
                    "c": 0,
                    "rs": 6,
                    "cs": 1
                },
                "1_1": {
                    "r": 1,
                    "c": 1,
                    "rs": 6,
                    "cs": 1
                },
            }
            let brr = []//车型项目名
            
            let borderArr = []//边框数据
            borderArr.push({
                "rangeType": "range",
                "borderType": "border-all",
                "style": "3",
                "color": "#a4a4a4",
                "range": [{
                    "row": [0, saleHeader.length+(this.carType.length*4)],
                    "column": [0, firstHeader.length+this.date.length-1]
                }]
            },)
            this.carType.map((item,i)=>{
                brr.push(...carTypeItem)
                mc.push({
                    "r": saleHeader.length+1+(i*4),
                    "c": 0,
                    "v": {
                        "v":item.carModelName,
                        'ht':0,
                    },
                    "mc": {       
                        "r": saleHeader.length+1+(i*4),   
                        "c": 0,   
                        "rs": 11, 
                        "cs": 2  
                    },
                },
               )
                merge[`${saleHeader.length+1+(i*4)}_0`] = { 
                    "r": saleHeader.length+1+(i*4),
                    "c": 0,
                    "rs": 4,
                    "cs": 2
                 }
                 
                 borderArr.push(
                    {
                    "rangeType": "range",
                    "borderType": "border-bottom",
                    "style": "8",
                    "color": "#77b8f9",
                    "range": [{
                        "row": [0, saleHeader.length+(i*4)],
                        "column": [0, firstHeader.length+this.date.length-1]
                    }]
                })

            })
            this.mydata[0].config.borderInfo = [...borderArr]
            // 车型合并项
            this.mydata[0].celldata.push(...mc)
            // 合并配置
            this.mydata[0].config.merge = merge
            brr.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:saleHeader.length+1+index,
                        c:2,
                        v:{ 
                            v:item,
                            ht:0
                        },
                    }
                )
            })
            this.fillPosition()
            // this.demo()
        },
        fillPosition(){
            let array = this.mydata[0].celldata
            array.map(a=>{
                this.tableData.expensePaymentScheduleEachCarModel.map(item=>{
                    if(a.v.v==item.carModelName){
                        item.r = a.r
                    }
                    item.freightPaidResultList.map(b=>{//运费
                        if(a.v.v==this.getExcelData(b.eachMonthLocalDate)){
                            b.c = a.c
                        }
                    })
                    item.dutyPaidResultList.map(b=>{//关税
                        if(a.v.v==this.getExcelData(b.eachMonthLocalDate)){
                            b.c = a.c
                        }
                    })

                })
                //合计
                this.tableData.expensePaymentScheduleEachMonth.map(item=>{
                    if(a.v.v==this.getExcelData(item.month)){
                            item.c = a.c
                        }
                })
                
            })
        
            this.fillData()
        },
        fillData(){
            this.tableData.expensePaymentScheduleEachCarModel.map(item=>{
                item.freightPaidResultList.map(data=>{//运费
                    this.mydata[0].celldata.push(
                        {
                            r:item.r,
                            c:data.c,
                            v:{ 
                                v:data.freightPaid,
                                ht:0
                            },
                        }
                    )
                })
                item.dutyPaidResultList.map(data=>{//关税
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+1,
                            c:data.c,
                            v:{ 
                                v:data.dutyPaid,
                                ht:0
                            },
                        }
                    )
                })
            
                item.otherCharges.map((data,i)=>{//其他
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+2,
                            c:i+5,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        }
                    )
                })
                item.totalChargesList.map((data,i)=>{//费用合计
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+3,
                            c:i+5,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        }
                    )
                })
                this.mydata[0].celldata.push(
                    {
                        r:item.r+0,
                        c:4,
                        v:{ 
                            v:item.freightPaidTotal, 
                            ht:0
                        },
                    },
                    {
                        r:item.r+1,
                        c:4,
                        v:{ 
                            v:item.dutyPaidTotal, 
                            ht:0
                        },
                    },
                    {
                        r:item.r+2,
                        c:4,
                        v:{ 
                            v:item.otherChargesTotal, 
                            ht:0
                        },
                    },
                    {
                        r:item.r+3,
                        c:4,
                        v:{ 
                            v:item.totalChargesTotal, 
                            ht:0
                        },
                    },
                )


            })
            this.tableData.expensePaymentScheduleEachMonth.map(data=>{
                this.mydata[0].celldata.push(
                    {
                        r:1,
                        c:data.c,
                        v:{ 
                            v:data.freightPaid,
                            ht:0
                        },
                    },
                    {
                        r:2,
                        c:data.c,
                        v:{ 
                            v:data.dutyPaid,
                            ht:0
                        },
                    },
                    {
                        r:3,
                        c:data.c,
                        v:{ 
                            v:data.otherExpenses,
                            ht:0
                        },
                    },
                    {
                        r:4,
                        c:data.c,
                        v:{ 
                            v:data.adjustment,
                            ht:0
                        },
                    },
                    {
                        r:5,
                        c:data.c,
                        v:{ 
                            v:data.totalCharges,
                            ht:0
                        },
                    },
                    {
                        r:6,
                        c:data.c,
                        v:{ 
                            v:data.adjustmentDescription,
                            ht:0
                        },
                    },
                )
            })
            let obj = this.tableData.expensePaymentScheduleColumn
            this.mydata[0].celldata.push(
                    {
                        r:1,
                        c:4,
                        v:{ 
                            v:obj.freightPaidSum,
                            ht:0
                        },
                    },
                    {
                        r:2,
                        c:4,
                        v:{ 
                            v:obj.dutyPaidSum,
                            ht:0
                        },
                    },
                    {
                        r:3,
                        c:4,
                        v:{ 
                            v:obj.otherExpensesSum,
                            ht:0
                        },
                    },
                    {
                        r:4,
                        c:4,
                        v:{ 
                            v:obj.adjustmentSum,
                            ht:0
                        },
                    },
                    {
                        r:5,
                        c:4,
                        v:{ 
                            v:obj.totalChargesSum,
                            ht:0
                        },
                    },
                    
                    
            )
            this.demo()
        },
        getExcelData(str){
            let arr = str.substr(0,7).split("-")
            let date;
            if(arr[1].substr(0,1)==0){
                date = arr[0]+'年'+arr[1].substr(1,2)+'月'
            }else{
                date = arr[0]+'年'+arr[1]+'月'
            }
            return date

        },
        
        
    },
    beforeDestroy(){
        window.luckysheet.exitEditMode();
        window.luckysheet.destroy();
        // 获取指定元素
        const scrollview = this.$refs['scrollview']
        // 移除监听
        scrollview.removeEventListener('scroll', this.scrollChange, true)
    },
}
</script>
<style lang="scss" scoped>
.order{
    min-height:calc(100vh - 100px);
    overflow: hidden;
    // background: pink;
    position: relative;
    #luckysheet{
        margin:0px;
        padding:0px;
        position:absolute;
        width:98%;
        box-sizing: border-box;
        left: 0px;
        top: 82px;
        bottom:0px;
        height: 88%;
    }
    .luck-btn{
        width: 100%;
        background: #fff;
        padding: 6px;
        box-sizing: border-box;
        margin-top: 50px;
        // align-items: center;
        p{
            font-size: 14px;
            color: #333;
            font-weight: bold;
            margin-right: 10px;
        }
        span{
            font-size: 12px;
            
        }
    }

}
</style>